<template>
    <div class="anchor-card">
        <NuxtLink :to="localePath({ name: 'the-project-project', params: { project: slug } })" class="block">
            <div
                class="thumbnail relative z-1"
                :class="{
                    'aspect-w-3 aspect-h-2': orientation === 'landscape' && !narrow,
                    'aspect-w-3 aspect-h-2 lg:aspect-w-2 lg:aspect-h-1': orientation === 'landscape' && narrow,
                    'aspect-w-3 aspect-h-2 lg:aspect-w-2 lg:aspect-h-3': orientation === 'portrait',
                    'aspect-w-3 aspect-h-2 lg:aspect-w-1 lg:aspect-h-1': orientation === 'square',
                    'rounded-[30px] lg:rounded-[40px]': rounding === 'base',
                    'rounded-[30px] lg:rounded-[80px]': rounding === 'medium',
                    'rounded-[30px] lg:rounded-full': rounding === 'full',
                }"
            >
                <picture>
                    <source media="(min-width:992px)" :srcset="imgSrcSet.md" />
                    <img :src="imgSrcSet.sm" :alt="title" :title="title" loading="lazy" />
                </picture>
            </div>

            <div
                class="border-l-[1px] border-black pt-8 pl-4 ml-8 -mt-8 relative z-2"
                :class="{ 'lg:ml-16': rounding === 'full' }"
            >
                <h3 class="font-Poppins font-semibold text-xl uppercase mt-4">{{ title }}</h3>
                <Button
                    tabindex="-1"
                    :label="$t('generic.read_more')"
                    class="p-button-secondary p-button-text -ml-2"
                    icon="pi pi-chevron-right"
                />
            </div>
        </NuxtLink>
    </div>
</template>

<script>
export default {
    name: 'PlaceCard',
    props: {
        slug: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        imgSrcSet: {
            type: Object,
            required: true,
        },
        narrow: {
            type: Boolean,
            required: false,
            default: false,
        },
        orientation: {
            type: String,
            required: false,
            default: 'square',
            validator(value) {
                if (!['square', 'landscape', 'portrait'].includes(value)) {
                    throw new Error('Invalid orientation value');
                }
                return true;
            },
        },
        rounding: {
            type: String,
            required: false,
            default: 'base',
            validator(value) {
                if (!['base', 'medium', 'full'].includes(value)) {
                    throw new Error('Invalid rounding value');
                }
                return true;
            },
        },
    },
};
</script>

<style scoped></style>
